import styled from '@emotion/styled'
export const StyleDropDownWrapper = styled.div<any>`
  border: 1px solid
    ${(props) =>
      props?.hasError
        ? props.theme.colors.danger
        : props.theme.colors.inputBorder};
  border-radius: 6px;
  height: 40px;
  display: flex;
  align-items: center;
  cursor: ${(props) => (props?.disabled ? 'not-allowed' : 'pointer')};
  justify-content: space-between;
  padding: 0px 10px;
  background: #fff;
  width: 100%;
  ${(props: any) => props.styleInput};
`

export const StyleDropDownOptionWrapper = styled.div<any>`
  width: 100%;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.1);
  position: absolute;
  z-index: 1111;
  top: ${(props) => props.top}px;
  ${(props: any) => props.styleOptionsWrapper};
`
export const StyleDropDownOptionItems = styled.ul<any>`
  width: 100%;
  background: ${(props) => props.theme.colors.white};
  max-height: 150px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`
export const StyleDropDownOption = styled.li<any>`
  padding: 7px 10px;
  font-size: 12px;
  background: ${(props) =>
    props.isActive ? props.theme.colors.primary : props.theme.colors.white};
  color: ${(props) =>
    props.isActive ? props.theme.colors.white : props.theme.colors.black};
  &:hover {
    background: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
  }
`

export const StyleSelectedItems = styled.div`
  display: flex;
  column-gap: 10px;
  flex: 100%;
  min-width: 0;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
`

export const StyleSelectedItem = styled.div<any>`
  display: flex;
  flex-direction: row;
  column-gap: 5px;
  align-items: center;
  background: ${(props: any) => props.theme.colors?.secondary};
  border-radius: 4px;
  padding: 4px 5px;
  font-size: 12px;
  white-space: nowrap;
  flex-shrink: 0;
  color: ${(props: any) => props.theme.colors.white};
`
export const StyleSelectedValue = styled.p<any>`
  color: ${(props) => props.theme.colors[props.tc ?? 'black']};
  font-size: 14px;
`
export const StyleDropDownSearchWrapper = styled.div<any>`
  padding: 10px 10px;
`
export const StyleDropDownSearchInput = styled.input<any>`
  width: 100%;
  border-radius: 4px;
  height: 40px;
  text-indent: 10px;
  padding: 0px;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  outline: none;
  font-size: 14px;
  &::placeholder {
    font-size: 12px;
    color: ${(props) => props.theme.colors.placeholder};
    font-family: Lato;
    font-weight: 300;
  }
`

export const StyleDropDownIconWrapper = styled.div`
  display: flex;
  column-gap: 10px;
`
